import React, { Component } from 'react';
import './LegalInfo.css';
import i18n from '../../i18n';
import logo from '../../kingLogoDark.svg';

const defaultCopyrightText =
    'King.com Ltd. King, the King crown logo, the game names and related marks are trade marks of King.com Ltd or related entities. All rights reserved.';

class LegalInfo extends Component {
    render() {
        const getCopy = (i18nKey) => i18n.getCopy(this.props.lang, i18nKey);
        return (
            <div className="LegalInfo">
                <div className="LegalInfo-logo">
                    <img className="LegalInfo-img" src={logo} alt="King crown logo" />
                </div>
                <ul>
                    <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.king.com/cookies">
                            Cookies
                        </a>
                    </li>
                    <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.king.com/privacyPolicy">
                            {getCopy('link.privacy_policy')}
                        </a>
                    </li>
                    {this.props.showHelp && (
                        <li>
                            <a rel="noopener noreferrer" href={window.location.origin}>
                                {getCopy('link.support_help')}
                            </a>
                        </li>
                    )}
                </ul>
                <p className="LegalInfo-message">{`© ${new Date().getFullYear()} ${defaultCopyrightText}`}</p>
            </div>
        );
    }
}

export default LegalInfo;



// WEBPACK FOOTER //
// ./src/components/LegalInfo/LegalInfo.js